<template>
  <v-main>
    <router-view></router-view>
    <notification></notification>
  </v-main>
</template>

<script>
    import notification from '@/components/core/Notification.vue';

    export default {
        name: 'DashboardCoreView',
        components: {
            notification
        },
    }
</script>